var map = {
	"./groupAffiliatesComponent.js": 7162,
	"./groupDescriptionComponent.js": 2833,
	"./groupGamesComponent.js": 5440,
	"./groupGamesItemComponent.js": 5397,
	"./groupMembersListComponent.js": 3724,
	"./groupStoreComponent.js": 6388,
	"./groupStoreItemComponent.js": 6889,
	"./groupWallComponent.js": 593
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4926;